import VdpUsed from 'vdp-used/components/VdpUsed/VdpUsed.jsx';
import VdpUsedProvider from 'vdp-used/VdpUsedProvider.jsx';
/* eslint prefer-default-export:0 */

const root = VdpUsed;
const provider = VdpUsedProvider;
const main = provider;

export const widgets = {
    VdpUsed: {
        components: {
            root,
            provider,
            main,
        },
    },
};

export default {
    root,
    provider,
    VdpUsed: main,
};
